
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.action-button {
  display: inline-block;
  cursor: pointer;
  position: relative;
}
.action-button span {
  padding: 12px 16px 12px 24px;
  background-color: var(--slh-color-primary-shade-40, #DAECFF);
  border-radius: 32px;
}
.action-button span slot[name=label]::slotted(*) {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  margin-right: 4px;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-m-font-size, 16px);
  line-height: var(--slh-base-xxs-line-height, 24px);
}
.action-button span:hover {
  background-color: var(--slh-color-primary-shade-60, #89B7E5);
}
.action-button .action-button-placeholder {
  display: flex;
  align-items: center;
  width: max-content;
}
.action-button .action-button-placeholder slh-admin-icon {
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.action-button.disabled span {
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
}
.action-button.disabled span slot[name=label]::slotted(*) {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.action-button.disabled .action-button-placeholder slh-admin-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}

*:focus {
  outline: none;
}

:host .action-button-items {
  max-width: 286px;
  white-space: nowrap;
  width: auto;
  position: absolute;
  visibility: hidden;
  display: none;
  padding: 8px 24px 8px 16px;
  overflow: auto;
  max-height: 176px;
  min-width: 100%;
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  border-radius: 8px;
  z-index: 1000;
  box-sizing: border-box;
  scrollbar-width: auto;
  scrollbar-color: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .action-button-items::-webkit-scrollbar {
  width: 4px !important;
}
:host .action-button-items::-webkit-scrollbar-track {
  background: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
  width: 4px !important;
}
:host .action-button-items::-webkit-scrollbar-thumb {
  background-color: var(--slh-color-neutral-shade-40, #C0C8D8);
  border-radius: 50px;
}
:host .action-button-items.align-right {
  right: 0;
  text-align: left;
}

.action-button span:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
}

.action-wrapper {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.action-wrapper .action-button slh-icon {
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.action-wrapper .action-button:hover slh-icon {
  fill: var(--slh-color-neutral, #39455D);
}
.action-wrapper .action-button:hover slot[name=label]::slotted(*) {
  color: var(--slh-color-neutral, #39455D);
}
.action-wrapper .action-button.secondary span {
  padding: 8px 8px 8px 16px;
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
}
.action-wrapper.open .action-button-items {
  display: block !important;
  visibility: visible;
}
.action-wrapper.disabled slh-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.action-wrapper.disabled:hover slh-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.action-wrapper.disabled:hover slot[name=label]::slotted(*) {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}

@media (max-width: 560px) {
  .action-wrapper {
    display: flex;
  }
  .action-wrapper .action-button {
    width: 100%;
  }
  .action-wrapper .action-button span {
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
  }
  .action-wrapper .action-button-items {
    max-width: 100%;
    width: 100%;
  }
}
`;
